export default __webpack_public_path__ + "assets/cart_mobile.png";